const NarvBarLeftPart2 = () => {
  return (
    <div>
      <div className="box-desc-footer-left-lealtad">
        <div>
          <p className="M-tittle-lealtad">Perfil de Consulta</p>
        </div>
        <div className="box-all-desc-lealtad">
          <div>
            <a className="a-ref-lealtad" href="#personal">
              <p className="desc-title-leftbar-lealtad">Información Personal</p>
            </a>
          </div>
          <div>
            <a className="a-ref-lealtad" href="#ABM ">
              <p className="desc-title-leftbar-lealtad">Abm de Documentos</p>
            </a>
          </div>
          <div>
            <a className="a-ref-lealtad" href="#Legajo ">
              <p className="desc-title-leftbar-lealtad">Legajo</p>
            </a>
          </div>
          <div>
            <a className="a-ref-lealtad" href="#economica">
              <p className="desc-title-leftbar-lealtad">
                Información Económica
              </p>
            </a>
          </div>
          <div>
            <a className="a-ref-lealtad" href="#income">
              <p className="desc-title-leftbar-lealtad">Pagos y Cobros</p>
            </a>
          </div>
          <div>
            <a className="a-ref-lealtad" href="#empleador">
              <p className="desc-title-leftbar-lealtad">
                Información Empleador
              </p>
            </a>
          </div>
          <div>
            <a className="a-ref-lealtad" href="#relacion">
              <p className="desc-title-leftbar-lealtad">
                Relación con la Mutual
              </p>
            </a>
          </div>
          <div>
            <a className="a-ref-lealtad" href="#politica">
              <p className="desc-title-leftbar-lealtad">Información Pep</p>
            </a>
          </div>
          <div>
            <a className="a-ref-lealtad" href="#terrorismo">
              <p className="desc-title-leftbar-lealtad">
                Información Terrorismo
              </p>
            </a>
          </div>
          <div>
            <a className="a-ref-lealtad" href="#matriz">
              <p className="desc-title-leftbar-lealtad">Matriz de Variables</p>
            </a>
          </div>
          <div>
            <a className="a-ref-lealtad" href="#glosario">
              <p className="desc-title-leftbar-lealtad">Glosario</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NarvBarLeftPart2;
